  const TOP_BLOCK = '.embroidery_top_block';
  const topDom = {
    _root: null,
    root() {
      if (this._root?.isConnected) return this._root;
      this._root = document.querySelector(TOP_BLOCK);
      return this._root;
    },
    get(id) { return document.getElementById(id); },
    qs(sel) {
      const root = this.root();
      return root ? root.querySelector(sel) : null;
    },
    qsa(sel) {
      const root = this.root();
      return root ? root.querySelectorAll(sel) : [];
    }
  };

  function isTopEmbroideryFlow() {
    return document.querySelector('.embroidery-popup-container')?.getAttribute('data-emb-screen') === 'topemb';
  }

  function setupTopCharCounter(inputId, countClass, errorClass = null) {
    try {
      const input = topDom.get(inputId);
      const scope = input?.closest('.engraving-form-container-top') || topDom.root();
      const counter = scope?.querySelector(`.${countClass}`);
      const error = errorClass ? scope?.querySelector(`.${errorClass}`) : null;
       const previewSvg = document.querySelector('.preview-text-overlay-svg');

      if (!input || !counter) throw new Error(`Missing elements for ${inputId}`);
      const maxLength = Number(input.maxLength) > 0 ? Number(input.maxLength) : 22;
      counter.textContent = `${input.value.length}/${maxLength}`;

      input.addEventListener("input", function () {
        try {
          const len = this.value.length;
          counter.textContent = `${len}/${maxLength}`;

          if (error && inputId === "top_inputline1") {
            const hasText = len > 0;
            error.toggleAttribute("data-hidden", hasText);
            setLine1CounterFull(counter, hasText);
            syncLine1HelperTextsTop();
          } else if (error) {
            if (len > 0) {
              error.style.display = "none";
              counter.style.width = "100%";
            } else {
              error.style.display = "block";
              counter.style.width = "unset";
            }
          }
         if (previewSvg && inputId !== "top_inputline2") {
          if (len > 0) {
            previewSvg.style.display = "none";
          } else {
            previewSvg.style.display = "block";
          }
        }
        } catch (innerError) {
          console.error(`Input handler error for ${inputId}:`, innerError);
        }
      }, { passive: true });
    } catch (error) {
      console.error(`Char counter init error for ${inputId}:`, error);
    }
  }
function isTopInputUpperCase(inputElement) {
  if (inputElement.style.textTransform === 'uppercase') return true;
  if (inputElement.style.textTransform === 'capitalize') return false;
  const trigger = inputElement.parentElement?.querySelector('.text_trasformation_name1');
  return !!trigger?.classList.contains('background_text');
}

const TOP_MOBILE_QUERY = '(max-width: 1023px)';

// Declared before initTopEmbroideryUi runs (it is called during script evaluation below)
let descUpdateRafTop = null;
let topIconSelectionId = 0;

// Coalesce description rebuilds (innerHTML + preview image) into one per frame;
// toggleCheckboxTop can fire 2-3 times for a single click via the nested onclick/onchange handlers
function scheduleUpdateDescriptionTop() {
  if (descUpdateRafTop) return;
  descUpdateRafTop = requestAnimationFrame(function () {
    descUpdateRafTop = null;
    updateDescriptionTop();
  });
}

// matchMedia never forces layout, unlike reading window.innerWidth
function isTopMobileViewport() {
  return window.matchMedia(TOP_MOBILE_QUERY).matches;
}

function getTopInputCasing(text, inputElement) {
  if (isTopInputUpperCase(inputElement)) {
    return text.toUpperCase();
  }

  return text
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function syncBottomInputTransformFromLine1Top(sourceInput, targetInput) {
  const isUpperCase = isTopInputUpperCase(sourceInput);
  const targetContainer = targetInput.closest('.engraving-form-container_transformation');
  const trigger = targetContainer?.querySelector('.text_trasformation_name1');
  const capital = trigger?.querySelector('.text_trasformation_name_captaln');
  const small = trigger?.querySelector('.text_trasformation_name_small');

  targetInput.style.textTransform = isUpperCase ? 'uppercase' : 'capitalize';
  if (capital) capital.style.display = isUpperCase ? 'block' : 'none';
  if (small) small.style.display = isUpperCase ? 'none' : 'block';
  if (trigger) trigger.classList.toggle('background_text', isUpperCase);
}

function setupInputTopSanitization(inputId) {
  const input = topDom.get(inputId);
  if (!input || input.dataset.topSanitized === 'true') return;
  input.dataset.topSanitized = 'true';

  const previewSelector = inputId === "top_inputline1" 
    ? ".preview-text-line1" 
    : inputId === "top_inputline2" 
    ? ".preview-text-line2" 
    : null;

  const previewElement = previewSelector ? document.querySelector(previewSelector) : null;

  input.addEventListener("input", function () {
    let sanitized = this.value.replace(/[^a-zA-Z0-9 .]/g, '');
    sanitized = getTopInputCasing(sanitized, this);
    // Only write back when something changed: skips a redundant value write (and caret reset) per keystroke
    if (sanitized !== this.value) this.value = sanitized;

    if (previewElement) {
      previewElement.textContent = sanitized;
    }
  }, { passive: true });

  input.addEventListener("paste", function (e) {
    const pastedData = (e.clipboardData || window.clipboardData).getData("text");
    if (/[^a-zA-Z0-9 .]/.test(pastedData)) {
      e.preventDefault();
    }
  });
}

let bottomEmbroideryAllowedTop;
function isBottomEmbroideryAllowedForProductTop() {
  if (bottomEmbroideryAllowedTop === undefined) {
    bottomEmbroideryAllowedTop = document.querySelector('.engraving-form-container-top')?.dataset?.enableBottomEmbroidery === 'true';
  }
  return bottomEmbroideryAllowedTop;
}

let line1RequiredErrorTop;
let line1RequiredErrorReady = false;
function getLine1RequiredErrorTop() {
  if (line1RequiredErrorReady) return line1RequiredErrorTop;
  line1RequiredErrorReady = true;
  const line1 = topDom.get('top_inputline1');
  const messageWrapper = line1?.closest('.engraving-form-container_transformation')?.nextElementSibling;
  line1RequiredErrorTop = messageWrapper?.classList.contains('message-wrapper')
    ? messageWrapper.querySelector('.error-message')
    : null;
  return line1RequiredErrorTop;
}

/**
 * Shows or hides an element without writing inline styles.
 * @param {Element|null|undefined} el
 * @param {boolean} hidden
 */
function setEmbHidden(el, hidden) {
  // Synchronous on purpose: callers read data-hidden right after (syncLine1HelperTextsTop, scrollToElement).
  // A deferred write left the old state visible to them, so the error and the pocket helper could both show.
  // Style work is still batched into the next frame, so deferring saved nothing.
  if (!el || el.hasAttribute('data-hidden') === hidden) return;
  el.toggleAttribute('data-hidden', hidden);
}

/**
 * Switches the line-1 counter between full width and shared with the error.
 * @param {Element|null|undefined} counter
 * @param {boolean} full
 */
function setLine1CounterFull(counter, full) {
  if (!counter) return;
  counter.toggleAttribute('data-full', full);
  counter.toggleAttribute('data-shared', !full);
}

function isLine1ErrorVisibleTop() {
  const error = getLine1RequiredErrorTop();
  return !!error && !error.hasAttribute('data-hidden');
}

let line1HelperBothTop;
let line1HelperPocketTop;
let line1HelpersReady = false;
function syncLine1HelperTextsTop() {
  if (!line1HelpersReady) {
    line1HelperBothTop = topDom.qs('.thistextapplytop_embroidery');
    line1HelperPocketTop = topDom.qs('.thistextapplytop_embroidery1');
    line1HelpersReady = true;
  }
  if (!line1HelperBothTop && !line1HelperPocketTop) return;

  const errorVisible = isLine1ErrorVisibleTop();
  const bottomToggleOn = !errorVisible && isBottomEmbroideryAllowedForProductTop() && !!topDom.get('top_bottomEmbroideryToggle')?.checked;
  setEmbHidden(line1HelperBothTop, errorVisible || !bottomToggleOn);
  setEmbHidden(line1HelperPocketTop, errorVisible || bottomToggleOn);
}

function showLine1RequiredErrorTop(container) {
  const error = container?.querySelector('.error-message');
  const counter = container?.querySelector('.char-count');
  setEmbHidden(error, false);
  setLine1CounterFull(counter, false);
  if (error) scrollToElement(error);
  syncLine1HelperTextsTop();
}

let bottomEmbroideryRafTop = null;

function syncBottomEmbroideryFromLine1Top() {
  if (!isBottomEmbroideryAllowedForProductTop()) return;

  const toggle = topDom.get('top_bottomEmbroideryToggle');
  const input = topDom.get('top_bottomEmbroideryInput');
  const line1 = topDom.get('top_inputline1');

  if (!toggle?.checked || !input || !line1) return;

  syncBottomInputTransformFromLine1Top(line1, input);

  const maxLength =
    Number(input.maxLength) > 0 ? Number(input.maxLength) : 22;

  const nextValue = getTopInputCasing(
    line1.value.slice(0, maxLength),
    line1
  );

  // Keep the value update synchronous.
  if (input.value !== nextValue) {
    input.value = nextValue;
  }

  // Capture the latest state for the next rendering frame.
  const nextCount = `${input.value.length}/${maxLength}`;
  const shouldHideError = input.value.length > 0;

  if (bottomEmbroideryRafTop !== null) {
    cancelAnimationFrame(bottomEmbroideryRafTop);
  }

  bottomEmbroideryRafTop = requestAnimationFrame(() => {
    bottomEmbroideryRafTop = null;

    const bottomCount = topDom.qs('.char-count-bottom');
    const bottomError = topDom.qs('.error-message-bottom');

    if (bottomCount && bottomCount.textContent !== nextCount) {
      const textNode =
        bottomCount.childNodes.length === 1 &&
        bottomCount.firstChild.nodeType === Node.TEXT_NODE
          ? bottomCount.firstChild
          : null;

      if (textNode) {
        textNode.nodeValue = nextCount;
      } else {
        bottomCount.textContent = nextCount;
      }
    }

    if (bottomError && shouldHideError &&
        bottomError.style.display !== 'none') {
      bottomError.style.display = 'none';
    }
  });
}

function setupBottomEmbroideryToggleTop() {
  if (!isBottomEmbroideryAllowedForProductTop()) return;
  const toggle = topDom.get('top_bottomEmbroideryToggle');
  const input = topDom.get('top_bottomEmbroideryInput');
  const wrap = topDom.qs('.bottom-embroidery-input-wrap');
  if (!toggle || !input || !wrap) return;

  const toggleLabel = topDom.qs('.bottom-embroidery-addon-bar__toggle');
  if (toggleLabel) {
    toggleLabel.addEventListener('click', function () {
      if (toggle.disabled) {
        const line1 = topDom.get('top_inputline1');
        const container = line1?.closest('.engraving-form-container_transformation');
        const msgWrapper = container?.nextElementSibling;
        const errorMsg = msgWrapper?.querySelector('.error-message');
        const charCount = msgWrapper?.querySelector('.char-count');
        setEmbHidden(errorMsg, false);
        setLine1CounterFull(charCount, false);
        if (line1) {
          line1.scrollIntoView({ behavior: 'smooth', block: 'center' });
          line1.focus();
        }
        syncLine1HelperTextsTop();
      }
    });
  }

  const bottomError = topDom.qs('.error-message-bottom');
  const bottomCount = topDom.qs('.char-count-bottom');
  wrap.style.removeProperty('display');

  function onBottomEmbroideryToggleChange() {
    const isChecked = toggle.checked;
    syncLine1HelperTextsTop();
    // The description rebuild runs once in the next frame, after the bottom input below is updated
    scheduleUpdateDescriptionTop();
    if (isChecked) syncBottomEmbroideryFromLine1Top();
    if (isChecked) return;
    setElementText(bottomCount, `0/${input.maxLength || 22}`);
    setEmbHidden(bottomError, true);
    if (input.value) input.value = '';
  }

  toggle.addEventListener('change', onBottomEmbroideryToggleChange);

  const line1 = topDom.get('top_inputline1');
  const textOption = topDom.get('text');
  if (line1) {
    line1.addEventListener('input', function () {
      syncBottomEmbroideryEligibilityTop();
      syncBottomEmbroideryFromLine1Top();
    }, { passive: true });
  }
  if (textOption) textOption.addEventListener('change', syncBottomEmbroideryEligibilityTop);
  syncBottomEmbroideryEligibilityTop();
}

function syncBottomEmbroideryEligibilityTop() {
  if (!isBottomEmbroideryAllowedForProductTop()) return;
  const toggle = topDom.get('top_bottomEmbroideryToggle');
  const input = topDom.get('top_bottomEmbroideryInput');
  const wrap = topDom.qs('.bottom-embroidery-input-wrap');
  const textOption = topDom.get('text');
  const line1 = topDom.get('top_inputline1');
  if (!toggle || !input || !wrap || !textOption || !line1) return;

  const canEnableBottom = textOption.checked && line1.value.trim().length > 0;
  // Runs on every line-1 keystroke; only touch :disabled when it flips (it feeds a :has(input:disabled) rule)
  if (toggle.disabled !== !canEnableBottom) toggle.disabled = !canEnableBottom;

  if (!canEnableBottom) {
    toggle.checked = false;
    input.value = '';
    if (wrap.style.display) wrap.style.removeProperty('display');
    syncLine1HelperTextsTop();
    const bottomError = topDom.qs('.error-message-bottom');
    const bottomCount = topDom.qs('.char-count-bottom');
    if (bottomError) bottomError.style.display = 'none';
    if (bottomCount) bottomCount.textContent = `0/${input.maxLength || 22}`;
  }
}

function getBottomVariantSkuTop() {
  const bottomVariantInput = document.getElementById('bottom_product_variant_id');
  const selectedBottomVariantId = bottomVariantInput?.value;
  if (!selectedBottomVariantId) return '';

  const variantScript = document.querySelector('script[data-picker-variants="bottom"]');
  if (!variantScript || !variantScript.textContent) return '';

  try {
    const bottomVariants = JSON.parse(variantScript.textContent);
    const matchedBottom = Array.isArray(bottomVariants)
      ? bottomVariants.find((v) => v && String(v.id) === String(selectedBottomVariantId))
      : null;
    return matchedBottom?.sku || '';
  } catch (e) {
    console.error('Unable to resolve bottom SKU', e);
    return '';
  }
}

  function setElementText(el, text) {
    if (!el) return;
    const textNode = el.childNodes.length === 1 && el.firstChild.nodeType === Node.TEXT_NODE ? el.firstChild : null;
    if (textNode) {
      if (textNode.nodeValue !== text) textNode.nodeValue = text;
      return;
    }
    if (el.textContent !== text) el.textContent = text;
  }

  function applyFontToPreviewTop(radio) {
    const previewText = document.querySelector('.preview-text-overlay');
    if (!previewText || !radio) return;

    const fontStyle = radio.getAttribute('data-fontstyle');
    previewText.style.fontFamily = fontStyle;
    if (fontStyle === 'Bookscript') {
      previewText.style.fontSize = isTopMobileViewport() ? '18px' : '24px';
      previewText.style.lineHeight = '1';
    } else {
      previewText.style.fontSize = '';
    }
  }

  function setTopButtonLoading(button, isLoading) {
    if (!button) return;
    button.toggleAttribute('data-loading', isLoading);
    button.toggleAttribute('aria-busy', isLoading);
  }

  // Loader styles live in embroidery-popup-bundle.liquid (button.*.popup-contentsecondlvl_*[data-loading])
  function setupPressLoaderTop(buttonSelector) {
    const button = topDom.qs(`.button-group-top ${buttonSelector}`);
    if (!button || button.dataset.topPressLoader === 'true') return;
    button.dataset.topPressLoader = 'true';

    // pointerdown is its own task before click, so the loader paints before the button's work starts
    button.addEventListener('pointerdown', function () {
      if (!button.disabled) button.toggleAttribute('data-loading', true);
    });
    // Press dragged off or cancelled: no click follows, so drop the loader unless the work is running
    ['pointerleave', 'pointercancel'].forEach(function (type) {
      button.addEventListener(type, function (e) {
        // On touch, pointerleave fires right before click, so only treat it as cancel for a mouse
        if (e.type === 'pointerleave' && e.pointerType !== 'mouse') return;
        if (!button.hasAttribute('aria-busy')) button.removeAttribute('data-loading');
      });
    });
  }

  // Button entry points: show the loader, yield so it paints, then run the work in one frame.
  // validateTopEmbroidery / handleTopEmbroideryAddedToCart stay synchronous for their other callers.
  function runWithTopButtonLoader(button, work) {
    if (button?.hasAttribute('aria-busy')) return;
    setTopButtonLoading(button, true);
    setTimeout(function () {
      requestAnimationFrame(function () {
        try {
          work();
        } finally {
          setTopButtonLoading(button, false);
        }
      });
    }, 0);
  }

  function resetTopEmbroideryFromButton(button) {
    runWithTopButtonLoader(button, function () { window.validateTopEmbroidery(); });
  }

  function proceedTopEmbroideryFromButton(button) {
    runWithTopButtonLoader(button, handleTopEmbroideryAddedToCart);
  }

  function syncTextColorLabelTop() {
    const selectedColor = topDom.qs('.embformColorcontainer .text-color-option input[type="radio"]:checked');
    const colorLabel = topDom.qs('.text-color-selector .top-current-selected-color');
    if (!selectedColor || !colorLabel) return;
    setElementText(colorLabel, selectedColor.value);
    const previewOverlay = document.querySelector('.preview-text-overlay');
    const nextColor = selectedColor.getAttribute('data-color');
    if (previewOverlay && nextColor && previewOverlay.style.color !== nextColor) {
      previewOverlay.style.color = nextColor;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopEmbroideryUi, { once: true });
  } else {
    initTopEmbroideryUi();
  }

  function initTopEmbroideryUi() {
    try {
    const textSection = topDom.qs('.engraving-form-container-top');
    const iconSection = topDom.qs('.embroidery_classic_IconWrapper-top');

    if (textSection) textSection.style.display = 'none';
    if (iconSection) iconSection.style.display = 'none';

    // One delegated listener per group instead of one per option
    const colorContainer = topDom.qs('.embformColorcontainer');
    if (colorContainer) {
      let colorSelectionId = 0;
      colorContainer.addEventListener('click', function (e) {
        const option = e.target.closest('.text-color-option');
        if (!option || !colorContainer.contains(option)) return;
        const radio = option.querySelector('input[type="radio"]');
        if (option.classList.contains('activess') && radio?.checked) return;

        // Instant highlight on the clicked swatch; the rest is non-urgent and runs after this paint
        option.classList.add('activess');
        const selectionId = ++colorSelectionId;
        setTimeout(() => {
          if (selectionId !== colorSelectionId) return;
          try {
            colorContainer.querySelectorAll('.text-color-option').forEach((opt) => {
              if (opt !== option) opt.classList.remove('activess');
            });
            if (!radio) return;
            radio.checked = true;
            syncTextColorLabelTop();
          } catch (err) {
            console.error('Color selection error:', err);
          }
        }, 0);
      });
    }

    const fontSelector = topDom.qs('.font-type-selector');
    if (fontSelector) {
      fontSelector.addEventListener('click', function (e) {
        const option = e.target.closest('.font-type-option');
        if (!option || !fontSelector.contains(option)) return;
        try {
          option.classList.add('activess');
          fontSelector.querySelectorAll('.font-type-option').forEach((opt) => {
            if (opt !== option) opt.classList.remove('activess');
          });
          const radio = option.previousElementSibling;
          if (!radio) return;
          radio.checked = true;
          applyFontToPreviewTop(radio);
        } catch (err) {
          console.error('Font selection error:', err);
        }
      });
    }

    setupPressLoaderTop('.popup-contentsecondlvl_reset');
    setupPressLoaderTop('.popup-contentsecondlvl_add');

    const selectedColor = topDom.qs('.text-color-option input[type="radio"]:checked');
    if (selectedColor) selectedColor.closest('.text-color-option')?.classList.add('activess');
    syncTextColorLabelTop();

    const selectedFont = topDom.qs('.font-type-selector input[type="radio"]:checked');
    if (selectedFont?.nextElementSibling) selectedFont.nextElementSibling.classList.add('activess');

    updatefeedImageTop();
    setupTopCharCounter("top_inputline1", "char-count", "error-message");
    setupTopCharCounter("top_inputline2", "char-count2");
    if (isBottomEmbroideryAllowedForProductTop()) {
      setupTopCharCounter("top_bottomEmbroideryInput", "char-count-bottom", "error-message-bottom");
      setupInputTopSanitization("top_bottomEmbroideryInput");
      setupBottomEmbroideryToggleTop();
    }
    setupInputTopSanitization("top_inputline1");
    setupInputTopSanitization("top_inputline2");
    updateActionButtonsTop();
    syncLine1HelperTextsTop();
    } catch (err) {
      console.error('initTopEmbroideryUi error:', err);
    }
  }

  function initTopEmbroideryEntry() {
    const textCheckbox = topDom.get('text');
    const textSection = topDom.qs('.engraving-form-container-top');
    const textPreview = document.querySelector('.preview-text-overlay');

    if (textCheckbox) textCheckbox.checked = true;
    if (textSection) textSection.style.display = 'block';
    if (textPreview) textPreview.style.display = 'block';

    const iconSection = topDom.qs('.embroidery_classic_IconWrapper-top');
    if (iconSection) iconSection.style.display = 'none';

    const iconCheckbox = topDom.get('icon');
    if (iconCheckbox) iconCheckbox.checked = false;

    updateActionButtonsTop();
    updateDescriptionTop();
    syncBottomEmbroideryEligibilityTop();
    syncTextColorLabelTop();
  }

  function selectDefaultIconTop() {
    topDom.qsa('.embroidery_classic_IconWrapper_classic-top input[name="top_icon"]').forEach((radio) => {
      radio.checked = false;
    });
    const defaultIconRadio = topDom.qs('.embroidery_classic_IconWrapper_classic_classicked-top input');
    if (defaultIconRadio) defaultIconRadio.checked = true;
    return defaultIconRadio;
  }

  function yieldToPaint() {
    if (typeof scheduler !== 'undefined' && typeof scheduler.yield === 'function') return scheduler.yield();
    return new Promise((resolve) => { setTimeout(resolve, 0); });
  }

  function toggleCheckboxTop(type, event) {
    try {
      if (type !== 'icon') {
        runToggleCheckboxTop(type);
        return;
      }
      const iconSection = topDom.qs('.embroidery_classic_IconWrapper-top');
      const iconCheckbox = topDom.get('icon');
      // The icon row's onclick is the only handler for this option and passes its click event.
      // A click on the checkbox itself has already been flipped by the browser before this runs;
      // any other click in the row (label text, price) must not let the label toggle it as well.
      const clickEvent = event && typeof event.preventDefault === 'function' ? event : null;
      const isNativeToggle = !!(clickEvent && iconCheckbox && clickEvent.target === iconCheckbox);
      if (clickEvent && !isNativeToggle) clickEvent.preventDefault();
      if (iconSection?.hasAttribute('data-emb-loading')) {
        // Ignored while opening: undo the browser's own flip so the box stays in sync
        if (isNativeToggle) clickEvent.preventDefault();
        return;
      }
      if (!iconCheckbox || !iconSection) {
        runToggleCheckboxTop(type);
        return;
      }
      const shouldCheck = isNativeToggle ? iconCheckbox.checked : !iconCheckbox.checked;
      if (!shouldCheck) {
        runToggleCheckboxTop('icon', false);
        return;
      }
      iconSection.setAttribute('data-emb-loading', '');
      iconSection.setAttribute('aria-busy', 'true');
      iconSection.style.display = 'block';
      yieldToPaint().then(() => {
        try {
          runToggleCheckboxTop('icon', true);
        } finally {
          iconSection.removeAttribute('data-emb-loading');
          iconSection.removeAttribute('aria-busy');
        }
      });
    } catch (err) {
      console.error('toggleCheckboxTop error:', err);
    }
  }

  // checked: explicit target state; omitted = flip the current state
  function runToggleCheckboxTop(type, checked) {
    try {
      const checkbox = topDom.get(type);
      const section = type === 'text' ? topDom.qs('.engraving-form-container-top') : topDom.qs('.embroidery_classic_IconWrapper-top');
      const sectionPreview = type === 'text' ? document.querySelector('.preview-text-overlay') : document.querySelector('.preview-image-wrapper');
      if (!checkbox || !section) return;

       const iconContainer = checkbox.closest('.embroidery-popup_option')?.querySelector('.embroidery-popup-input_iconcontainer svg');

      checkbox.checked = typeof checked === 'boolean' ? checked : !checkbox.checked;
      section.style.display = checkbox.checked ? 'block' : 'none';
      if (sectionPreview) sectionPreview.style.display = checkbox.checked ? 'block' : 'none';
       if (iconContainer) {
      iconContainer.classList.toggle('emb-rotated', checkbox.checked);
    }

      // Handle icon option unchecked - remove attribute if it exists and reset custom upload
      if (type === 'icon' && !checkbox.checked) {
        const embroideryBox = document.querySelector(".embroidery-box-rewamp");
        if (embroideryBox && embroideryBox.hasAttribute("data-selected-variant-img")) {
          embroideryBox.removeAttribute("data-selected-variant-img");
        }
        
        // Reset custom upload section
        const customUploadSection = topDom.qs('.reicon_box.reoption_row.recustomImageUploadDivision.recustomUploadImageEmbroidery');
        if (customUploadSection) {
          const fileInput = document.getElementById('customLogoUpload');
          const preview = topDom.get('top_imagePreview');
          const fileNameLabel = topDom.get('top_fileNameText');
          const charCountSize = topDom.qs('.char-countsize');
          const errorMessage = topDom.qs('.error-message-uploded');
          
          if (fileInput) fileInput.value = '';
          if (preview) {
            preview.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" fill="#616161"/>
              </svg>`;
          }
          if (fileNameLabel) fileNameLabel.textContent = 'Upload Your custom Logo';
          if (charCountSize) charCountSize.textContent = '0/5MB';
          if (errorMessage) errorMessage.style.display = 'none';
          
          // Clear live preview image
          const LivepreviewIcon = document.querySelector('.preview-image-wrapper');
          if (LivepreviewIcon) LivepreviewIcon.innerHTML = '';
        }
        
        selectDefaultIconTop();
      }

      if (type === 'icon' && checkbox.checked) {
        selectDefaultIconTop();
        updatefeedImageTop();
      }

      scheduleUpdateDescriptionTop();
      updateActionButtonsTop();
      syncBottomEmbroideryEligibilityTop();
      const checkedIcon = topDom.qs(".embroidery_classic_IconWrapper_classic-top input:checked");
      const data_SelectedAlt = checkedIcon?.getAttribute("data-alt");
      if (data_SelectedAlt) {
        const wrapper = checkedIcon.closest(".embroidery_classic_IconWrapper_targetClose");
        const colorDisplay = wrapper?.previousElementSibling?.querySelector(".current-selected-colorText .top-current-selected-color");
        if (colorDisplay) {
          colorDisplay.textContent = data_SelectedAlt || "";
        }
      }

    } catch (err) {
      console.error('toggleCheckboxTop error:', err);
    }
  }

function updateActionButtonsTop() {
  try {
    const isTextChecked = topDom.get('text')?.checked;
    const isIconChecked = topDom.get('icon')?.checked;

    const buttonGroup = topDom.qs('.button-group-top');
    const confirmButton = topDom.qs('.embroidery-popup_confirm-button-top');
    const engravingInfo = topDom.qs('.engraving-info-top');

    if (buttonGroup && confirmButton) {
      if (isTextChecked || isIconChecked) {
        buttonGroup.style.display = 'flex';
        confirmButton.style.display = 'none';
      } else {
        buttonGroup.style.display = 'none';
        confirmButton.style.display = 'block';
      }
    }

    if (engravingInfo) {
      engravingInfo.style.display = isIconChecked ? 'block' : 'none';
    }
  } catch (err) {
    console.error('updateActionButtonsTop error:', err);
  }
}

function getEmbroideryVariants() {
  return window.embroideryProductTop?.variants || [];
}

function findEmbroideryVariantByTitle(title) {
  const normalized = String(title || '').trim().toLowerCase();
  return getEmbroideryVariants().find((variant) => String(variant?.title || '').trim().toLowerCase() === normalized) || null;
}

function formatEmbroideryMoneyFromCents(cents) {
  const amount = Number(cents || 0) / 100;
  return `₹ ${amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

/**
 * Friendly label for "Embroidery Selected:" (variant title → display copy).
 * @param {string} variantTitle
 * @returns {string}
 */
function getEmbroiderySelectionDisplayLabel(variantTitle) {
  const key = String(variantTitle || '').trim().toLowerCase();
  const labels = {
    'my name': 'Text',
    'icon/logo': 'Icon',
    'custom logo': 'Custom Icon',
    'my name and custom logo': 'Text + Logo',
    both: 'Text + Icon',
    'both text': 'Both text',
    'both text and icon': 'Both Text + Icon',
    'both text and logo': 'Both Text + Logo',
  };
  return labels[key] !== undefined ? labels[key] : String(variantTitle || '').trim();
}

function getCurrentEmbroiderySelection() {
  const textChecked = !!topDom.get('text')?.checked;
  const iconChecked = !!topDom.get('icon')?.checked;
  const bottomAllowed = isBottomEmbroideryAllowedForProductTop();
  const bottomChecked = bottomAllowed && !!topDom.get('top_bottomEmbroideryToggle')?.checked;
  const hasCustomLogoUpload = !!document.querySelector('#customLogoUpload')?.value?.trim();

  if (textChecked && iconChecked) {
    if (bottomChecked && hasCustomLogoUpload) return { title: 'Both Text and Logo' };
    if (bottomChecked) return { title: 'Both Text and Icon' };
    if (hasCustomLogoUpload) return { title: 'My Name and Custom Logo' };
    return { title: 'Both' };
  }

  if (textChecked) {
    if (bottomChecked) return { title: 'Both Text' };
    return { title: 'My Name' };
  }

  if (iconChecked) {
    if (hasCustomLogoUpload) return { title: 'Custom Logo' };
    return { title: 'Icon/Logo' };
  }

  return null;
}


  let lastTopDescKey = '';

  function showTopDescriptionFallback(desc) {
    if (lastTopDescKey === 'fallback') {
      desc.classList.remove('emb-msgupdated');
      return;
    }
    lastTopDescKey = 'fallback';
    let fallback = desc.querySelector('p');
    const needsRebuild = !fallback || desc.children.length !== 1 || fallback.querySelector('.EmbSelected_title');
    if (needsRebuild) {
      desc.replaceChildren();
      fallback = document.createElement('p');
      fallback.appendChild(document.createTextNode('Embroidery Selected'));
      desc.appendChild(fallback);
    } else {
      setElementText(fallback, 'Embroidery Selected');
    }
    desc.classList.remove('emb-msgupdated');
  }

  let topDescTimer = null;
  let topDescRaf = null;
  let pendingTopDescUpdate = null;

  
function updateDescriptionTop() {
  try {
    const desc = topDom.qs('.embroidery-popup-description');
    if (!desc) return;

    const selection = getCurrentEmbroiderySelection();
    const variant = selection
      ? findEmbroideryVariantByTitle(selection.title)
      : null;

    if (!variant) {
      showTopDescriptionFallback(desc);
      return;
    }

    const compareAtPrice =
      Number(variant.compare_at_price) > Number(variant.price)
        ? Number(variant.compare_at_price)
        : null;

    const displayLabel =
      getEmbroiderySelectionDisplayLabel(variant.title);

    const priceText =
      formatEmbroideryMoneyFromCents(variant.price);

    const compareText = compareAtPrice
      ? formatEmbroideryMoneyFromCents(compareAtPrice)
      : '';

    const nextKey =
      `${variant.id}|${priceText}|${compareText}|${displayLabel}`;

    if (nextKey === lastTopDescKey) {
      return;
    }

    // Keep only the latest pending update.
    pendingTopDescUpdate = {
      desc,
      nextKey,
      displayLabel,
      priceText,
      compareText
    };

    clearTimeout(topDescTimer);

    topDescTimer = setTimeout(() => {
      // Cancel an older frame if it has not executed yet.
      if (topDescRaf !== null) {
        cancelAnimationFrame(topDescRaf);
      }

      topDescRaf = requestAnimationFrame(() => {
        topDescRaf = null;

        const update = pendingTopDescUpdate;
        if (!update || !update.desc.isConnected) return;

        const {
          desc,
          nextKey,
          displayLabel,
          priceText,
          compareText
        } = update;

        if (nextKey === lastTopDescKey) return;

        // Create the structure only when required.
        let title = desc.querySelector('.EmbSelected_title');
        let price = desc.querySelector('.EmbSelected_price');

        if (!title || !price) {
          const summary = document.createElement('p');
          summary.append('Embroidery Selected: ');

          title = document.createElement('label');
          title.className = 'EmbSelected_title';
          summary.appendChild(title);

          price = document.createElement('span');
          price.className = 'EmbSelected_price';

          desc.replaceChildren(summary, price);
        }

        // Update text only when it has actually changed.
        if (title.textContent !== displayLabel) {
          title.textContent = displayLabel;
        }

        let priceTextNode = price.firstChild;

        if (
          !priceTextNode ||
          priceTextNode.nodeType !== Node.TEXT_NODE
        ) {
          priceTextNode = document.createTextNode('');
          price.insertBefore(priceTextNode, price.firstChild);
        }

        if (priceTextNode.textContent !== priceText) {
          priceTextNode.textContent = priceText;
        }

        let compare = price.querySelector('.compare-at-price');

        if (compareText) {
          if (!compare) {
            compare = document.createElement('span');
            compare.className = 'compare-at-price';
            price.appendChild(compare);
          }

          if (compare.hasAttribute('data-hidden')) {
            compare.removeAttribute('data-hidden');
          }

          if (compare.textContent !== compareText) {
            compare.textContent = compareText;
          }
        } else if (compare && !compare.hasAttribute('data-hidden')) {
          compare.setAttribute('data-hidden', '');
        }

        if (!desc.classList.contains('emb-msgupdated')) {
          desc.classList.add('emb-msgupdated');
        }

        lastTopDescKey = nextKey;

        updatefeedImageTop();
      });
    }, 0);

  } catch (err) {
    console.error('updateDescriptionTop error:', err);
  }
}


  function handleFileUploadTop(event) {
    try {
      const classicIcon = topDom.qs('.embroidery_classic_IconWrapper_classic-top input:checked');
      const preview = topDom.get('top_imagePreview');
      const LivepreviewIcon = document.querySelector('.preview-image-wrapper');
      const fileNameLabel = topDom.get('top_fileNameText');
      const charCountSize = topDom.qs('.char-countsize');
      const errorMessage = topDom.qs('.error-message-uploded');

      if (classicIcon) classicIcon.checked = false;
      topDom.qsa(".top-current-selected-color").forEach(el => {
        el.innerText = "";
      });
      syncTextColorLabelTop();

      const file = event.target.files[0];
      if (file) {
        fileNameLabel.textContent = file.name;

         const fileSizeMB = (file.size / 1024 / 1024).toFixed(2); // File size in MB
    const maxFileSize = 5; 
    charCountSize.textContent = `${fileSizeMB}MB / ${maxFileSize}MB`;
      if (fileSizeMB > maxFileSize) {
  if (errorMessage) {
    errorMessage.textContent = `File size exceeds the maximum limit of ${maxFileSize}MB.`;
    errorMessage.style.color = 'red';
    errorMessage.style.display = 'block';
  }
  charCountSize.innerHTML = `<span style="color: red;">${fileSizeMB}MB</span> / ${maxFileSize}MB`;
  charCountSize.style.width = 'unset';
} else {
  if (errorMessage) {
    errorMessage.style.display = 'none';
  }
  charCountSize.innerHTML = `${fileSizeMB}MB / ${maxFileSize}MB`;
  charCountSize.style.width = '50%';
}

        const reader = new FileReader();
        reader.onload = function (e) {
          preview.innerHTML = '';
          LivepreviewIcon.innerHTML = '';
          const isMobile = window.innerWidth < 1024;
           const imgPreview = document.createElement('img');
  imgPreview.src = e.target.result;
  imgPreview.width = 24;
  imgPreview.height = 24;
  Object.assign(imgPreview.style, { width: '24px', height: '24px', objectFit: 'cover' });
  preview.appendChild(imgPreview);

  const imgLivePreview = document.createElement('img');
  imgLivePreview.src = e.target.result;
  imgLivePreview.width = isMobile ? 105 : 160;
  imgLivePreview.height = isMobile ? 105 : 160;
  imgLivePreview.loading = 'lazy';
  imgLivePreview.decoding = 'async';
  Object.assign(imgLivePreview.style, {
    width: isMobile ? '105px' : '160px',
    height: isMobile ? '105px' : '160px',
    objectFit: 'cover'
  });
  LivepreviewIcon.appendChild(imgLivePreview);
            
            // Upload image to API and get CDN link
            const base64Data = e.target.result;
            const base64String = base64Data.split(',')[1]; // Remove data:image/png;base64, prefix
            const mimeType = base64Data.match(/data:([^;]+);/)?.[1] || 'image/png';
            const imageName = file.name || 'embroidery-image.png';
            
            // Get the ADD button and disable it with loading state
            const addButton = topDom.qs('.button-group-top .add-btn.popup-contentsecondlvl_add');
            const originalButtonText = addButton ? addButton.textContent : 'ADD';
            
            if (addButton) {
              addButton.disabled = true;
              addButton.textContent = 'Loading...';
              addButton.style.opacity = '0.6';
              addButton.style.cursor = 'not-allowed';
            }
            
            // Disable embroidery option clicks
            const embroideryOptions = topDom.qsa('.embroidery-popup_option, .embroidery-popup_optionIcon');
            embroideryOptions.forEach(option => {
              option.style.pointerEvents = 'none';
              option.style.opacity = '0.6';
              option.style.cursor = 'not-allowed';
            });
            
            // Disable embroidery icon clicks
            const embroideryIcons = topDom.qsa(".embroidery-icon");
            embroideryIcons.forEach(icon => {
              icon.style.pointerEvents = 'none';
              icon.style.opacity = '0.6';
              icon.style.cursor = 'not-allowed';
            });

            // Lock page interactions while upload is in progress
            const pageRoot = document.body;
            const previousBodyPointerEvents = pageRoot ? pageRoot.style.pointerEvents : '';
            const previousBodyCursor = pageRoot ? pageRoot.style.cursor : '';
            if (pageRoot) {
              pageRoot.style.pointerEvents = 'none';
              pageRoot.style.cursor = 'wait';
            }
            
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
              "imageName": imageName,
              "mimeType": mimeType,
              "imageData": base64String
            });

            const requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow"
            };

            fetch("https://51pupuk2pk.execute-api.ap-south-1.amazonaws.com/image?type=uploadImage", requestOptions)
              .then((response) => response.json())
              .then((result) => {
                // Extract CDN link from response - check originalSrc first
                const cdnLink = result.originalSrc || result.url || result.imageUrl || result.cdnUrl || result.link || result.data?.originalSrc || result.data?.url || result.data?.imageUrl || result.data?.cdnUrl || result.data?.link;
                
                // Check if icon option is checked before setting attribute
                const isIconChecked = topDom.get('icon')?.checked;
                const embroideryBox = document.querySelector(".embroidery-box-rewamp");
                
                if (cdnLink) {
                  // Set CDN link in data attribute only if icon option is checked
                  if (isIconChecked && embroideryBox && document.querySelector("#customLogoUpload").value) {

                    embroideryBox.setAttribute("data-selected-variant-img", cdnLink);
                  }
                  // Update preview images to use CDN link
                  imgPreview.src = cdnLink;
                  imgLivePreview.src = cdnLink;
                } else {
                  // Fallback to base64 if CDN link not found
                  console.warn('CDN link not found in API response, using base64:', result);
                }
                
                // Re-enable button after successful upload
                if (addButton) {
                  addButton.disabled = false;
                  addButton.textContent = originalButtonText;
                  addButton.style.opacity = '1';
                  addButton.style.cursor = 'pointer';
                }
                
                // Re-enable embroidery option clicks
                const embroideryOptions = topDom.qsa('.embroidery-popup_option, .embroidery-popup_optionIcon');
                embroideryOptions.forEach(option => {
                  option.style.pointerEvents = '';
                  option.style.opacity = '';
                  option.style.cursor = '';
                });
                
                // Re-enable embroidery icon clicks
                const embroideryIcons = topDom.qsa(".embroidery-icon");
                embroideryIcons.forEach(icon => {
                  icon.style.pointerEvents = '';
                  icon.style.opacity = '';
                  icon.style.cursor = '';
                });

                // Unlock page interactions after upload completes
                if (pageRoot) {
                  pageRoot.style.pointerEvents = previousBodyPointerEvents;
                  pageRoot.style.cursor = previousBodyCursor;
                }
              })
              .catch((error) => {
                console.error('Error uploading image to API:', error);
                const embroideryBox = document.querySelector(".embroidery-box-rewamp");
                const checkedRadios = topDom.qsa(
                  ".embroidery_classic_IconWrapper_classic-top input[type=radio]:checked"
                );

                if (checkedRadios.length > 0 && embroideryBox?.hasAttribute("data-selected-variant-img")) {
                  embroideryBox.removeAttribute("data-selected-variant-img");
                }
                // Re-enable button after error
                if (addButton) {
                  addButton.disabled = false;
                  addButton.textContent = originalButtonText;
                  addButton.style.opacity = '1';
                  addButton.style.cursor = 'pointer';
                }
                
                // Re-enable embroidery option clicks
                const embroideryOptions = topDom.qsa('.embroidery-popup_option, .embroidery-popup_optionIcon');
                embroideryOptions.forEach(option => {
                  option.style.pointerEvents = '';
                  option.style.opacity = '';
                  option.style.cursor = '';
                });
                
                // Re-enable embroidery icon clicks
                const embroideryIcons = topDom.qsa(".embroidery-icon");
                embroideryIcons.forEach(icon => {
                  icon.style.pointerEvents = '';
                  icon.style.opacity = '';
                  icon.style.cursor = '';
                });

                // Unlock page interactions after upload error
                if (pageRoot) {
                  pageRoot.style.pointerEvents = previousBodyPointerEvents;
                  pageRoot.style.cursor = previousBodyCursor;
                }
              });
           
        };
        reader.readAsDataURL(file);

        updateDescriptionTop();
      }
    } catch (err) {
      console.error('handleFileUploadTop error:', err);
    }
  }

  // The bundle snippet's document-wide label listener sets data-selecting on click for an instant border
  function clearTopIconSelectingState() {
    topDom.qsa('.embroidery_classic_IconWrapper_classic-top label.embroidery-icon[data-selecting]').forEach((label) => {
      label.removeAttribute('data-selecting');
    });
  }

  function handleTopEmbroiderySelect(event) {
    const selectionId = ++topIconSelectionId;

    // Non-urgent work: yield the main thread so the radio's checked state paints first,
    // then batch all DOM writes into a single frame. A newer selection cancels this one.
    setTimeout(function () {
      if (selectionId !== topIconSelectionId) return;
      requestAnimationFrame(function () {
        if (selectionId !== topIconSelectionId) return;
        applyTopEmbroiderySelect();
        clearTopIconSelectingState();
      });
    }, 0);
  }

  function applyTopEmbroiderySelect() {
    try {
      const fileInput = document.getElementById('customLogoUpload');
      const fileNameLabel = topDom.get('top_fileNameText');
      const preview = topDom.get('top_imagePreview');
      const desc = topDom.qs('.embroidery-popup-description');
      // Clear custom logo upload if it exists and has a value
      if (fileInput && fileInput.value) {
        fileInput.value = '';
        if (preview) {
          preview.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" fill="#616161"/>
            </svg>`;
        }
        if (fileNameLabel) {
          fileNameLabel.textContent = 'Upload Your custom Logo';
        }
        const errorMessageUploaded = topDom.qs(".error-message-uploded");
        if (errorMessageUploaded) {
          errorMessageUploaded.style.display = "none";
        }
        const charCountSize = topDom.qs('.char-countsize');
        if (charCountSize) {
          charCountSize.textContent = `0 / 5MB`;
        }
        const charCountSizeSpan = topDom.qs('span.char-count.char-countsize');
        if (charCountSizeSpan) {
          charCountSizeSpan.style.width = `50%`;
        }
      }
       var checkedRadios11 = topDom.qsa(
        ".embroidery_classic_IconWrapper_classic-top input[type=radio]:checked"
      );

      // If at least one radio is checked and embroideryBox has the attribute
      const embroideryBox11 = document.querySelector(".embroidery-box-rewamp");
      if (checkedRadios11.length > 0 && embroideryBox11?.hasAttribute("data-selected-variant-img")) {
        embroideryBox11.removeAttribute("data-selected-variant-img");
      }
      // Update description with currently selected combination
      if (desc) updateDescriptionTop();

      // Always redraw here: updateDescriptionTop returns early when the variant is unchanged (e.g. icon A -> icon B),
      // so it can't be relied on for the image. updatefeedImageTop skips the DOM write when the image is the same.
      updatefeedImageTop();
    } catch (err) {
      console.error('handleTopEmbroiderySelect error:', err);
    }
  }

  function scrollToElement(el) {
  if (
    el &&
    typeof el.scrollIntoView === 'function' &&
    !el.classList.contains('message-wrapper-customUpload')
  ) {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}


function handleTopEmbroideryAddedToCart() {
  try {
    const selectedTextOption = topDom.qs(".embroidery-popup_option.embroidery-popup_optionText input:checked");
    const selectedIconOption = topDom.qs(".embroidery-popup_option.embroidery-popup_optionIcon input:checked");

    const engravingLine1 = topDom.get("top_inputline1");
    const isEngravingValid = engravingLine1 && engravingLine1.value.trim() !== "";

    const isClassicOptionSelected = topDom.qs('.embroidery_classic_IconWrapper_classic-top input:checked');
    const customLogoUpload = document.querySelector('#customLogoUpload');
    const uploadedFile = customLogoUpload && customLogoUpload.files && customLogoUpload.files[0];
    const isFileValid = uploadedFile && uploadedFile.size <= 5 * 1024 * 1024;
    const bottomToggle = topDom.get('top_bottomEmbroideryToggle');
    const bottomInput = topDom.get('top_bottomEmbroideryInput');
    const isBottomEnabled = isBottomEmbroideryAllowedForProductTop() && !!bottomToggle?.checked;
    const isBottomTextValid = !isBottomEnabled || !!bottomInput?.value?.trim();

    if (selectedTextOption && selectedIconOption) {

      if (!isEngravingValid) {
        showLine1RequiredErrorTop(engravingLine1.closest(".engraving-form-container-top"));
      }

      if (!isClassicOptionSelected && !(uploadedFile && isFileValid)) {
        const errorMessage = topDom.qs("small.error-message.error-message-uploded");
        if (errorMessage) {
          errorMessage.style.display = "block";
          if (uploadedFile && uploadedFile.size > 5 * 1024 * 1024) {
            errorMessage.textContent = "Uploaded file must be smaller than 5MB.";
          }
          scrollToElement(errorMessage);
        }
      }
      if (!isBottomTextValid) {
        const bottomError = topDom.qs('.error-message-bottom');
        const bottomCount = topDom.qs('.char-count-bottom');
        if (bottomError) bottomError.style.display = "block";
        if (bottomCount) bottomCount.style.width = "unset";
        if (bottomError) scrollToElement(bottomError);
      }

      // Proceed only if BOTH conditions are valid
      if (isEngravingValid && (isClassicOptionSelected || (uploadedFile && isFileValid)) && isBottomTextValid) {
        const embroideryInput = topDom.qs(".embroidery-popup-input.emb-padding");
        const embroideryInputdescription = topDom.qs(".embroidery-popup-description.emb-padding");
        if (embroideryInput) embroideryInput.style.display = "none";
        if (embroideryInputdescription) embroideryInputdescription.style.display = "none";

        const finalEmbroideryInfo = topDom.root()?.querySelector(".finalEmbroidery_info");
        if (finalEmbroideryInfo) finalEmbroideryInfo.style.display = "block";
      }

      return; 
    }


    if (selectedTextOption) {
      const customLogoUploadInput = document.querySelector("#customLogoUpload");
      if (customLogoUploadInput) {
        customLogoUploadInput.value = "";
      }
      if (!isEngravingValid) {
        showLine1RequiredErrorTop(engravingLine1.closest(".engraving-form-container-top"));
        return;
      }
      if (!isBottomTextValid) {
        const bottomError = topDom.qs('.error-message-bottom');
        const bottomCount = topDom.qs('.char-count-bottom');
        if (bottomError) bottomError.style.display = "block";
        if (bottomCount) bottomCount.style.width = "unset";
        if (bottomError) scrollToElement(bottomError);
        return;
      }

      const embroideryInput = topDom.qs(".embroidery-popup-input.emb-padding");
      const embroideryInputdescription = topDom.qs(".embroidery-popup-description.emb-padding");
      if (embroideryInput) embroideryInput.style.display = "none";
      if (embroideryInputdescription) embroideryInputdescription.style.display = "none";

      const finalEmbroideryInfo = topDom.root()?.querySelector(".finalEmbroidery_info");
      if (finalEmbroideryInfo) finalEmbroideryInfo.style.display = "block";
    }

    // --- Handle single icon option ---
    else if (selectedIconOption) {
      if (isClassicOptionSelected || (uploadedFile && isFileValid)) {
        const embroideryInput = topDom.qs(".embroidery-popup-input.emb-padding");
        const embroideryInputdescription = topDom.qs(".embroidery-popup-description");
        if (embroideryInput) embroideryInput.style.display = "none";
        if (embroideryInputdescription) embroideryInputdescription.style.display = "none";

        const finalEmbroideryInfo = topDom.root()?.querySelector(".finalEmbroidery_info");
        if (finalEmbroideryInfo) finalEmbroideryInfo.style.display = "block";
      } else {
        const errorMessage = topDom.qs("small.error-message.error-message-uploded");
        if (errorMessage) {
          errorMessage.style.display = "block";
          if (uploadedFile && uploadedFile.size > 5 * 1024 * 1024) {
            errorMessage.textContent = "Uploaded file must be smaller than 5MB.";
          }
          scrollToElement(errorMessage);

        }
      }
    }

  } catch (error) {
    console.error("Error in handleTopEmbroideryAddedToCart:", error);
  }
}



function gobackTopEmbroidery() {
  try{
      const finalInfo = topDom.root()?.querySelector(".finalEmbroidery_info");
      if (finalInfo) finalInfo.style.display = "none";  
     const popupInput = topDom.qs(".embroidery-popup-input.emb-padding");
      if (popupInput) popupInput.style.display = "block";
    const embroideryInputdescription = topDom.qs(".embroidery-popup-description.emb-padding");
    if (embroideryInputdescription) embroideryInputdescription.style.display = "flex";
  } catch (error) {
    console.error("Error in gobackTopEmbroidery:", error);
  }
}

window.validateTopEmbroidery = function() {
  const textOptionCheckbox = topDom.get('text');
  const isTextSelected = textOptionCheckbox?.checked;
  const isIconSelected = topDom.qs(".embroidery-popup_option.embroidery-popup_optionIcon input:checked");
   const previewSvg1 = document.querySelector('.preview-text-overlay-svg');

  // Cancel any pending icon-selection work so it can't redraw the preview after the reset
  topIconSelectionId++;
  clearTopIconSelectingState();

  // === Reset Text Engraving Option ===
  if (isTextSelected) {
    const line1Input = topDom.get('top_inputline1');
    const line2Input = topDom.get('top_inputline2');

    if (line1Input) line1Input.value = '';
    if (line2Input) line2Input.value = '';
    if (previewSvg1) previewSvg1.style.display = "block";


    textOptionCheckbox.checked = false;

    const textEngravingContainer = document.querySelector('.engraving-form-container-top');
    if (textEngravingContainer) textEngravingContainer.style.display = 'none';

    const iconToggle = textOptionCheckbox.closest('.embroidery-popup_option')?.querySelector('.embroidery-popup-input_iconcontainer svg');
    if (iconToggle) iconToggle.classList.remove('emb-rotated');

    updateDescriptionTop();
    updateActionButtonsTop();
  }
  if (isBottomEmbroideryAllowedForProductTop()) {
    const bottomToggle = topDom.get('top_bottomEmbroideryToggle');
    const bottomInput = topDom.get('top_bottomEmbroideryInput');
    const bottomWrap = topDom.qs('.bottom-embroidery-input-wrap');
    const bottomError = topDom.qs('.error-message-bottom');
    const bottomCount = topDom.qs('.char-count-bottom');
    if (bottomToggle) {
      bottomToggle.checked = false;
      bottomToggle.disabled = true;
    }
    if (bottomInput) bottomInput.value = '';
    if (bottomWrap?.style.display) bottomWrap.style.removeProperty('display');
    syncLine1HelperTextsTop();
    if (bottomError) bottomError.style.display = 'none';
    if (bottomCount) bottomCount.textContent = '0/22';
  }

  // === Reset Icon/Logo Upload Option ===
  if (isIconSelected) {
    const logoInput = document.getElementById('customLogoUpload');
    const logoPreview = topDom.get('top_imagePreview');
    const fileNameLabel = topDom.get('top_fileNameText');

    if (logoInput) logoInput.value = '';
    if (logoPreview) {
      logoPreview.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" fill="#616161"/>
        </svg>`;
    }
    if (fileNameLabel) fileNameLabel.textContent = 'Upload Your custom Logo';

    const uploadError = topDom.qs(".error-message-uploded");
    if (uploadError) uploadError.style.display = "none";

    const sizeText = topDom.qs('.char-countsize');
    if (sizeText) sizeText.textContent = `0 / 5MB`;

    const sizeBar = topDom.qs('span.char-count.char-countsize');
    if (sizeBar) sizeBar.style.width = `50%`;

    selectDefaultIconTop();

    // Uncheck the icon option checkbox and update UI
    const iconCheckbox = topDom.get('icon');
    if (iconCheckbox) {
      toggleCheckboxTop('icon', true);
    }
  }
    // Clear preview text and image
    const previewTextLine1 = document.querySelector(".preview-text-line1");
    const previewTextLine2 = document.querySelector(".preview-text-line2");
    const previewImageWrapper = document.querySelector(".preview-image-wrapper");

    if (previewTextLine1) previewTextLine1.innerHTML = '';
    if (previewTextLine2) previewTextLine2.innerHTML = '';
    if (previewImageWrapper) previewImageWrapper.innerHTML = '';
}
function handleTopEmbroideryConfirmation() {
  const isTextOptionSelected = topDom.qs(".embroidery-popup_option.embroidery-popup_optionText input")?.checked;
  const isIconOptionSelected = topDom.qs(".embroidery-popup_option.embroidery-popup_optionIcon input")?.checked;
  const logoUploadValue = document.querySelector("#customLogoUpload")?.value?.trim();
  const bottomEmbroideryEnabled = isBottomEmbroideryAllowedForProductTop() && !!topDom.get('top_bottomEmbroideryToggle')?.checked;
  const bottomEmbroideryText = isBottomEmbroideryAllowedForProductTop()
    ? (topDom.get('top_bottomEmbroideryInput')?.value?.trim() || '')
    : '';
  const bottomEmbroiderySku = bottomEmbroideryEnabled ? getBottomVariantSkuTop() : '';
  const embroiderySection = document.querySelector(".embroidery-box-rewamp");
  if (!embroiderySection) return;

  document.querySelectorAll("input[name='emb_firstscreen_option']").forEach((radio) => {
    if (radio.checked) {
      const embrtype = radio.value;
      const editLabel = embroiderySection.querySelector('.added_list label[data-embrtype]');
      if (editLabel) {
        editLabel.removeAttribute('data-embrtype');
        editLabel.setAttribute('data-embrtype', embrtype);
      }
    }
  });

  embroiderySection.querySelector("input.embroidery_filled").checked = true;
  embroiderySection.querySelector(".popupbtnembroidery").checked = false;
  embroiderySection.querySelector(".added_list").style.display = "block";
  embroiderySection.querySelector(".embMaiDiv").style.display = "none";
  embroiderySection.querySelector(".btn_pack").style.display = "none";

  // Hide all views initially
  embroiderySection.querySelector(".list_row_only_Text").style.display = "none";
  embroiderySection.querySelector(".list_row_only_Image").style.display = "none";
  embroiderySection.querySelector(".list_row_both").style.display = "none";
  const bottomTextRow = embroiderySection.querySelector(".list_row_only_Text_bottom");
  if (bottomTextRow) bottomTextRow.style.display = "none";

  window.selectedVariant = null;
  let selectedVariant = null;

  if (isTextOptionSelected && isIconOptionSelected) {
    applyBothEmbroidery(embroiderySection);

    // ✅ Both selected: check for Custom Logo
    if (bottomEmbroideryEnabled && logoUploadValue) {
      selectedVariant = findEmbroideryVariantByTitle("Both Text and Logo");
    } else if (bottomEmbroideryEnabled) {
      selectedVariant = findEmbroideryVariantByTitle("Both Text and Icon");
    } else if (logoUploadValue) {
      selectedVariant = findEmbroideryVariantByTitle("My Name and Custom Logo");
    } else {
      selectedVariant = findEmbroideryVariantByTitle("Both");
    }

  } else if (isTextOptionSelected) {
    applyTextEmbroidery(embroiderySection);

    // ✅ Text only / top + bottom text
    if (bottomEmbroideryEnabled) {
      selectedVariant = findEmbroideryVariantByTitle("Both Text");
    } else {
      selectedVariant = findEmbroideryVariantByTitle("My Name");
    }

  } else if (isIconOptionSelected) {
    applyIconEmbroidery(embroiderySection);

    // ✅ Icon only: check for Custom Logo
    if (logoUploadValue) {
      selectedVariant = findEmbroideryVariantByTitle("Custom Logo");
    } else {
      selectedVariant = findEmbroideryVariantByTitle("Icon/Logo");
    }
  }

  if (selectedVariant) {
    window.selectedVariant = selectedVariant;
    document.querySelector(".embroidery-box-rewamp").setAttribute("data-selected-variant-id", selectedVariant.id);
    const embroideryDisplayTitle = getEmbroiderySelectionDisplayLabel(selectedVariant.title);
    embroiderySection.querySelectorAll('.property_line__textEmbWrapper h4').forEach((titleEl) => {
      titleEl.innerText = embroideryDisplayTitle;
    });
// ✅ Set price based on variant title
    const priceElement = embroiderySection.querySelector(".box_price");
    if (priceElement) {
      priceElement.innerText = formatEmbroideryMoneyFromCents(selectedVariant.price);
    }
    
  } else {
    console.warn("No matching variant found.");
  }

  embroiderySection.querySelectorAll('.property_line_BottomText').forEach((row) => {
    const valueNode = row.querySelector('.property_line_BottomTextValue');
    if (bottomEmbroideryEnabled && bottomEmbroideryText) {
      row.style.display = 'block';
      if (valueNode) valueNode.innerText = bottomEmbroideryText;
    } else {
      row.style.display = 'none';
      if (valueNode) valueNode.innerText = '';
    }
  });
  if (bottomEmbroideryEnabled && bottomEmbroideryText) {
    embroiderySection.setAttribute('data-bottom-embroidery-enabled', 'true');
    embroiderySection.setAttribute('data-bottom-embroidery-text', bottomEmbroideryText);
    if (bottomEmbroiderySku) {
      embroiderySection.setAttribute('data-bottom-embroidery-sku', bottomEmbroiderySku);
    } else {
      embroiderySection.removeAttribute('data-bottom-embroidery-sku');
    }
  } else {
    embroiderySection.removeAttribute('data-bottom-embroidery-enabled');
    embroiderySection.removeAttribute('data-bottom-embroidery-text');
    embroiderySection.removeAttribute('data-bottom-embroidery-sku');
  }

  closeEmbroideryPopup();
  document.querySelector(".popupbtnembroidery").checked = true;
  if (typeof checkAllSelections === 'function') {
    checkAllSelections();
  }
}

function applyTextEmbroidery(section) {
  const textSection = section.querySelector(".list_row_only_Text");

  const line1 = topDom.get("top_inputline1").value;
  const line2 = topDom.get("top_inputline2").value || "";
  const textColor = topDom.qs(".text-color-options input:checked")?.value || "";
  const fontStyle = topDom.qs(".font-type-selector input:checked")?.value || "";

  textSection.querySelector(".selected-Name-centered .emb_first_Maind").innerText = line1;
  textSection.querySelector(".selected-Name-centered .emb_sec_opt").innerText = line2;
  // Only show line2 if it has a value, otherwise just show line1
  const displayText = line2.trim() ? `${line1}, ${line2}` : line1;
  section.querySelector("span.property_line__textEmb.property_line__textEmbfirst").innerText = displayText;
  textSection.querySelector("span.property_line.property_line_colorValue").innerText = textColor;
  textSection.querySelector("span.property_line_FontStyle").innerText = fontStyle;

  textSection.style.display = "grid";
}

function applyIconEmbroidery(section) {
  const iconSection = section.querySelector(".list_row_only_Image");
  const selectedIcon = topDom.qs(".embroidery_classic_IconWrapper_classic-top input:checked");
  const customUpload = document.querySelector("#customLogoUpload");

  if (selectedIcon) {
    const iconUrl = selectedIcon.getAttribute("data-icon-url");
    
    iconSection.querySelector(".showIcon").innerHTML = `<img src="${iconUrl}" height="50">`; 
    iconSection.querySelector(".property_line_Iconname_Name").innerText = selectedIcon.getAttribute("data-alt");
  } else if (customUpload?.value) {
    const iconUrl = customUpload.getAttribute("data-icon-url");
    iconSection.querySelector(".showIcon").innerHTML = "customupload";
    iconSection.querySelector(".property_line_Iconname_Name").innerText = "customupload";
  }

  iconSection.style.display = "grid";
}

function applyBothEmbroidery(section) {
  const bothSection = section.querySelector(".list_row_both");

  const line1 = topDom.get("top_inputline1").value;
  const line2 = topDom.get("top_inputline2").value || "";
  const textColor = topDom.qs(".text-color-options input:checked")?.value || "";
  const fontStyle = topDom.qs(".font-type-selector input:checked")?.value || "";

  const selectedIcon = topDom.qs(".embroidery_classic_IconWrapper_classic-top input:checked");
  const customUpload = document.querySelector("#customLogoUpload");

  // Fill text side
  bothSection.querySelector(".selected-Name-centered .emb_first_Maind").innerText = line1;
  bothSection.querySelector(".selected-Name-centered .emb_sec_opt").innerText = line2;
  // Only show line2 if it has a value, otherwise just show line1
  const displayText = line2.trim() ? `${line1}, ${line2}` : line1;
  bothSection.querySelector(".property_line__textEmb.property_line__textEmbfirst").innerText = displayText;
  bothSection.querySelector(".property_line_color span:last-child").innerText = textColor;
  bothSection.querySelector(".property_line_Font span:last-child").innerText = fontStyle;

  // Fill icon side
  if (selectedIcon) {
    const iconUrl = selectedIcon.getAttribute("data-icon-url"); 
    bothSection.querySelector(".showIcon").innerHTML = `<img src="${iconUrl}" height="50">`;
    bothSection.querySelector(".property_line_Iconname span:last-child").innerText = selectedIcon.getAttribute("data-alt") || "Selected Icon";
  } else if (customUpload?.value) {
    const iconUrl = customUpload.getAttribute("data-icon-url");
    bothSection.querySelector(".showIcon").innerHTML = "customupload";
    bothSection.querySelector(".property_line_Iconname span:last-child").innerText = "customupload";
  }

  bothSection.style.display = "grid"; // or "block" based on layout
}

function setTopOptionChecked(type, checked) {
  const checkbox = topDom.get(type);
  const section = type === 'text' ? topDom.qs('.engraving-form-container-top') : topDom.qs('.embroidery_classic_IconWrapper-top');
  const sectionPreview = type === 'text'
    ? document.querySelector('.preview-text-overlay')
    : document.querySelector('.preview-image-wrapper');
  if (!checkbox) return;

  checkbox.checked = checked;
  if (section) section.style.display = checked ? 'block' : 'none';
  if (sectionPreview) sectionPreview.style.display = checked ? 'block' : 'none';

  const iconContainer = checkbox.closest('.embroidery-popup_option')?.querySelector('.embroidery-popup-input_iconcontainer svg');
  if (iconContainer) iconContainer.classList.toggle('emb-rotated', checked);
}

function setTopColorSelection(colorName) {
  if (!colorName) return;
  const normalized = colorName.trim().toLowerCase();
  topDom.qsa('.text-color-option input[type="radio"]').forEach((radio) => {
    if (String(radio.value).trim().toLowerCase() !== normalized) return;
    radio.checked = true;
    topDom.qsa('.text-color-option').forEach((opt) => opt.classList.remove('activess'));
    radio.closest('.text-color-option')?.classList.add('activess');
    syncTextColorLabelTop();
  });
}

function setTopFontSelection(fontName) {
  if (!fontName) return;
  const normalized = fontName.trim().toLowerCase();
  topDom.qsa('.font-type-selector input[type="radio"]').forEach((radio) => {
    if (String(radio.value).trim().toLowerCase() !== normalized) return;
    radio.checked = true;
    topDom.qsa('.font-type-option').forEach((opt) => opt.classList.remove('activess'));
    radio.nextElementSibling?.classList.add('activess');
    const previewText = document.querySelector('.preview-text-overlay');
    if (!previewText) return;
    const fontStyle = radio.getAttribute('data-fontstyle');
    previewText.style.fontFamily = fontStyle;
    if (fontStyle === 'Bookscript') {
      previewText.style.fontSize = isTopMobileViewport() ? '18px' : '24px';
      previewText.style.lineHeight = '1';
    }
  });
}

function setTopIconSelection(iconName, iconUrl) {
  const radios = topDom.qsa('.embroidery_classic_IconWrapper_classic-top input[name="top_icon"]');
  radios.forEach((radio) => { radio.checked = false; });

  const normalizedName = (iconName || '').trim().toLowerCase();

  // Custom logo: select upload radio only — never fall back to a classic icon.
  if (normalizedName === 'customupload' || (!normalizedName && !iconUrl)) {
    const customRadio = topDom.get('top_inputClickedd');
    if (customRadio) customRadio.checked = true;
    topDom.qsa('.embroidery_classic_IconWrapper-top .top-current-selected-color').forEach((el) => {
      el.textContent = '';
    });
    return;
  }

  const matched = Array.from(radios).find((radio) => {
    const alt = (radio.getAttribute('data-alt') || '').trim().toLowerCase();
    const url = radio.getAttribute('data-icon-url') || '';
    return (normalizedName && alt && (alt === normalizedName || normalizedName.includes(alt) || alt.includes(normalizedName)))
      || (iconUrl && url && iconUrl.includes(url));
  });

  if (matched) matched.checked = true;
  else selectDefaultIconTop();
}

function restoreTopEmbroideryFromAdded() {
  try {
    const box = document.querySelector('.embroidery-box-rewamp');
    if (!box) return;

    const textRow = box.querySelector('.list_row_only_Text');
    const imageRow = box.querySelector('.list_row_only_Image');
    const bothRow = box.querySelector('.list_row_both');
    const hasBoth = bothRow && bothRow.style.display !== 'none';
    const hasText = !hasBoth && textRow && textRow.style.display !== 'none';
    const hasIcon = !hasBoth && imageRow && imageRow.style.display !== 'none';

    setTopOptionChecked('text', false);
    setTopOptionChecked('icon', false);

    const previewSvg = document.querySelector('.preview-text-overlay-svg');
    const previewLine1 = document.querySelector('.preview-text-line1');
    const previewLine2 = document.querySelector('.preview-text-line2');

    if (hasBoth || hasText) {
      const source = hasBoth ? bothRow : textRow;
      const line1 = source.querySelector('.emb_first_Maind')?.textContent?.trim() || '';
      const line2 = source.querySelector('.emb_sec_opt')?.textContent?.trim() || '';
      const colorNode = hasBoth
        ? bothRow.querySelector('.property_line_color span:last-child')
        : textRow.querySelector('.property_line_colorValue');
      const fontNode = hasBoth
        ? bothRow.querySelector('.property_line_Font span:last-child')
        : textRow.querySelector('.property_line_FontStyle');
      const color = colorNode?.textContent?.trim() || '';
      const font = fontNode?.textContent?.trim() || '';

      setTopOptionChecked('text', true);

      const line1Input = topDom.get('top_inputline1');
      const line2Input = topDom.get('top_inputline2');
      if (line1Input) {
        line1Input.value = line1;
        line1Input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (line2Input) {
        line2Input.value = line2;
        line2Input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (previewLine1) previewLine1.textContent = line1;
      if (previewLine2) previewLine2.textContent = line2;
      if (previewSvg) previewSvg.style.display = line1 ? 'none' : 'block';

      setTopColorSelection(color);
      setTopFontSelection(font);
    }

    if (hasBoth || hasIcon) {
      const source = hasBoth ? bothRow : imageRow;
      const iconName = source.querySelector('.property_line_Iconname_Name, .property_line_Iconname span:last-child')
        ?.textContent?.trim() || '';
      const iconUrl = source.querySelector('.showIcon img')?.getAttribute('src') || '';
      setTopOptionChecked('icon', true);
      setTopIconSelection(iconName, iconUrl);
      updatefeedImageTop();
    }

    if (isBottomEmbroideryAllowedForProductTop()) {
      const bottomEnabled = box.getAttribute('data-bottom-embroidery-enabled') === 'true';
      const bottomText = box.getAttribute('data-bottom-embroidery-text') || '';
      const bottomToggle = topDom.get('top_bottomEmbroideryToggle');
      const bottomInput = topDom.get('top_bottomEmbroideryInput');
      const bottomWrap = topDom.qs('.bottom-embroidery-input-wrap');

      if (bottomToggle) {
        bottomToggle.disabled = false;
        bottomToggle.checked = bottomEnabled;
      }
      if (bottomWrap?.style.display) bottomWrap.style.removeProperty('display');
      syncLine1HelperTextsTop();
      if (bottomInput && bottomEnabled) {
        bottomInput.value = bottomText;
        bottomInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    updateDescriptionTop();
    updateActionButtonsTop();
    syncBottomEmbroideryEligibilityTop();
    syncTextColorLabelTop();
  } catch (error) {
    console.error('restoreTopEmbroideryFromAdded error:', error);
  }
}
  
window.EmbroideryDeleteTop = function () {
  try {
    const embroideryBox = document.querySelector(".embroidery-box-rewamp");

    // Uncheck the filled checkbox and popup selector
    embroideryBox.querySelector("input.embroidery_filled").checked = false;
    embroideryBox.querySelector(".popupbtnembroidery").checked = false;

    // Reset visibility
    embroideryBox.querySelector(".added_list").style.display = "none";
    embroideryBox.querySelector(".embMaiDiv").style.display = "block";
    embroideryBox.querySelector(".btn_pack").style.display = "flex";
    embroideryBox.querySelector(".list_row_only_Text").style.display = "none";
    embroideryBox.querySelector(".list_row_only_Image").style.display = "none";
    embroideryBox.querySelector(".list_row_both").style.display = "none";
    const bottomTextRow = embroideryBox.querySelector(".list_row_only_Text_bottom");
    if (bottomTextRow) bottomTextRow.style.display = "none";

    // Clear text inputs
    topDom.get("top_inputline1").value = "";
    topDom.get("top_inputline2").value = "";

    // Clear text section fields
    const textSection = embroideryBox.querySelector(".list_row_only_Text .selected-Name-centered");
    if (textSection) {
      textSection.querySelector(".emb_first_Maind").innerText = "";
      textSection.querySelector(".emb_sec_opt").innerText = "";
    }
    embroideryBox.querySelector("span.property_line__textEmb.property_line__textEmbfirst").innerText = "";
    const textColorSpan = embroideryBox.querySelector("span.property_line.property_line_colorValue");
    if (textColorSpan) textColorSpan.innerText = "";
    const fontStyleSpan = embroideryBox.querySelector("span.property_line_FontStyle");
    if (fontStyleSpan) fontStyleSpan.innerText = "";

    // Clear icon section fields
    const iconImg = embroideryBox.querySelector(".list_row_only_Image .showIcon img");
    if (iconImg) iconImg.src = "";
    const iconNameSpan = embroideryBox.querySelector(".property_line_Iconname_Name");
    if (iconNameSpan) iconNameSpan.innerText = "";
    embroideryBox.querySelectorAll(".property_line_BottomText").forEach((row) => {
      row.style.display = "none";
    });
    embroideryBox.querySelectorAll(".property_line_BottomTextValue").forEach((valueNode) => {
      valueNode.innerText = "";
    });

    // Clear 'both' section fields
    const bothSection = embroideryBox.querySelector(".list_row_both");
    if (bothSection) {
      bothSection.querySelector(".emb_first_Maind").innerText = "";
      bothSection.querySelector(".emb_sec_opt").innerText = "";
      bothSection.querySelector(".property_line__textEmb.property_line__textEmbfirst").innerText = "";
      bothSection.querySelector(".property_line_color span:last-child").innerText = "";
      bothSection.querySelector(".property_line_Font span:last-child").innerText = "";
      bothSection.querySelector(".property_line_Iconname span:last-child").innerText = "";
      const bothIconImg = bothSection.querySelector(".showIcon img");
      if (bothIconImg) bothIconImg.src = "";
    }

    // Hide selector UI
    const selector = document.querySelector(".emb_select_opt");
    if (selector) selector.style.display = "none";
    embroideryBox.removeAttribute('data-bottom-embroidery-enabled');
    embroideryBox.removeAttribute('data-bottom-embroidery-text');
    embroideryBox.removeAttribute('data-bottom-embroidery-sku');

    // Target the Edit button that carries data-embrtype, not the hidden .edit_box before it:
    // adding the attribute there makes confirm handlers save the type to the wrong label
    const editLabel = embroideryBox.querySelector('.added_list label.edit_box[data-embrtype]');
    if (editLabel) editLabel.setAttribute('data-embrtype', '');

    validateTopEmbroidery()
    gobackTopEmbroidery()

  } catch (error) {
    console.error("Error in EmbroideryDelete:", error.message);
  }
};


  function handleTopEmbroideryEdited(editLabel) {
  try {
    if (typeof window.openEmbroideryEditPicker === 'function') {
      window.openEmbroideryEditPicker(editLabel);
      return;
    }

    const body = document.querySelector("body");
    const popup = document.getElementById("embroideryPopup");

    if (popup) {
      popup.style.display = "flex";
    }

    body.classList.add("bodyEmbhidden");
    gobackTopEmbroidery();
  } catch (error) {
    console.error("Error in handleTopEmbroideryEdited:", error.message);
  }
}

function chnageTextTransformation_top(trigger) {
  const container = trigger.closest('.engraving-form-container_transformation');
  const input = container.querySelector('input');

  if (!input) return;

  const isUpperCase = input.style.textTransform === "uppercase";
  let newValue;

  if (isUpperCase) {
    // Switch to Capitalize
    input.style.textTransform = "capitalize";
    newValue = input.value.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    input.value = newValue;

    trigger.querySelector(".text_trasformation_name_captaln").style.display = "none";
    trigger.querySelector(".text_trasformation_name_small").style.display = "block";
    trigger.classList.remove("background_text");
  } else {
    // Switch to Uppercase
    input.style.textTransform = "uppercase";
    newValue = input.value.toUpperCase();
    input.value = newValue;

    trigger.querySelector(".text_trasformation_name_captaln").style.display = "block";
    trigger.querySelector(".text_trasformation_name_small").style.display = "none";
    trigger.classList.add("background_text");
  }
  if (input.id === "top_inputline1") {
    const previewLine1 = document.querySelector(".preview-text-line1");
    if (previewLine1) previewLine1.textContent = input.value;
    syncBottomEmbroideryFromLine1Top();
  } else if (input.id === "top_inputline2") {
    const previewLine2 = document.querySelector(".preview-text-line2");
    if (previewLine2) previewLine2.textContent = input.value;
  }
}

function updatefeedImageTop() {
  try {
    const LivepreviewIcon = document.querySelector('.preview-image-wrapper');
    if (!LivepreviewIcon) return;

    const previewImg = topDom.qs("#top_imagePreview img");
    const selectedIconInput = topDom.qs(".embroidery_classic_IconWrapper_classic-top input:checked");
    const textColorLabel = topDom.qs('.text-color-selector .top-current-selected-color');
    const iconLabels = topDom.qsa(".top-current-selected-color");

    let imageUrl = '';
    let imageALT = '';
    iconLabels.forEach((el) => {
      if (el !== textColorLabel) setElementText(el, '');
    });

if (previewImg && previewImg.getAttribute("src")) {
  imageUrl = previewImg.getAttribute("src");
} else if (selectedIconInput) {
  imageUrl = selectedIconInput.getAttribute("data-icon-url");
  imageALT = selectedIconInput.getAttribute("data-alt");
}

    const currentImg = LivepreviewIcon.querySelector('img');
    const currentSrc = currentImg ? currentImg.getAttribute('src') || '' : '';
    if (currentSrc !== imageUrl) {
      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.loading = 'lazy';
        img.decoding = 'async';
        LivepreviewIcon.replaceChildren(img);
      } else {
        LivepreviewIcon.replaceChildren();
      }
    }
    if(imageALT){
      // Try to find the wrapper from the event if available, otherwise search for the selected icon's parent
      let wrapper = null;
      if (typeof event !== 'undefined' && event && event.target && event.target instanceof Element) {
        wrapper = event.target.closest(".embroidery_classic_IconWrapper_targetClose");
      }
      if (!wrapper && selectedIconInput) {
        wrapper = selectedIconInput.closest(".embroidery_classic_IconWrapper_targetClose");
      }
      if (wrapper) {
        const colorDisplay = wrapper.previousElementSibling?.querySelector(".current-selected-colorText .top-current-selected-color");
        if (colorDisplay) setElementText(colorDisplay, imageALT || '');
      }
    }

    syncTextColorLabelTop();
  } catch (error) {
    console.error("updatefeedImageTop in EmbroideryEdited:", error.message);
  }
}

(function installTopEmbroideryRoutes() {
  const bundleHandlers = {
    confirm: window.handleEmbroideryConfirmation,
    goback: window.gobackEmbroidery,
    fileUpload: window.handleFileUpload,
    delete: window.EmbroideryDelete,
    edited: window.EmbroideryEdited
  };

  function getSavedEmbrType() {
    return document.querySelector(
      '.embroidery-box-rewamp .added_list label[data-embrtype], .embroidery-box .added_list label[data-embrtype]'
    )?.getAttribute('data-embrtype');
  }

  window.handleTopEmbroideryConfirmation = handleTopEmbroideryConfirmation;
  window.handleFileUploadTop = handleFileUploadTop;
  window.handleTopEmbroiderySelect = handleTopEmbroiderySelect;
  window.handleTopEmbroideryAddedToCart = handleTopEmbroideryAddedToCart;
  window.resetTopEmbroideryFromButton = resetTopEmbroideryFromButton;
  window.proceedTopEmbroideryFromButton = proceedTopEmbroideryFromButton;
  window.gobackTopEmbroidery = gobackTopEmbroidery;
  window.initTopEmbroideryEntry = initTopEmbroideryEntry;
  window.toggleCheckboxTop = toggleCheckboxTop;
  window.chnageTextTransformation_top = chnageTextTransformation_top;
  window.handleTopEmbroideryEdited = handleTopEmbroideryEdited;
  window.restoreTopEmbroideryFromAdded = restoreTopEmbroideryFromAdded;

  window.handleEmbroideryConfirmation = function () {
    if (isTopEmbroideryFlow()) {
      handleTopEmbroideryConfirmation();
    } else if (bundleHandlers.confirm) {
      bundleHandlers.confirm();
    }
    if (typeof checkAllSelections === 'function') {
      checkAllSelections();
    }
  };

  window.gobackEmbroidery = function (embrtype) {
    if (isTopEmbroideryFlow()) return gobackTopEmbroidery();
    if (bundleHandlers.goback) return bundleHandlers.goback(embrtype);
  };

  window.handleFileUpload = function (event) {
    if (isTopEmbroideryFlow()) return handleFileUploadTop(event);
    if (bundleHandlers.fileUpload) return bundleHandlers.fileUpload(event);
  };

  window.EmbroideryDelete = function () {
    const embrtype = getSavedEmbrType();
    if (isTopEmbroideryFlow() || embrtype === 'topemb') return window.EmbroideryDeleteTop();
    if (bundleHandlers.delete) return bundleHandlers.delete();
  };

  window.EmbroideryEdited = function (editLabel) {
    if (typeof window.openEmbroideryEditPicker === 'function') {
      return window.openEmbroideryEditPicker(editLabel);
    }
    const embrtype = editLabel?.getAttribute?.('data-embrtype') || getSavedEmbrType();
    if (embrtype === 'bottomemb') {
      if (bundleHandlers.edited) return bundleHandlers.edited(editLabel);
      return;
    }
    if (isTopEmbroideryFlow() || embrtype === 'topemb') return handleTopEmbroideryEdited(editLabel);
    if (bundleHandlers.edited) return bundleHandlers.edited(editLabel);
  };
})();